@for (column of columns; track column) {
  @switch (column.type) {
    @case (EnumColumnType.DATE) {
      <ng-container *ngTemplateOutlet="DateCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.LINK) {
      <ng-container *ngTemplateOutlet="LinkCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.BUTTON) {
      <ng-container *ngTemplateOutlet="ButtonCol; context: { params: { col: column } }"></ng-container>
    }
    @case (EnumColumnType.BUTTONS) {
      <ng-container *ngTemplateOutlet="ButtonsCol; context: { params: { col: column } }"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="SimpleCol; context: { params: { col: column } }"></ng-container>
    }
  }
}

<ng-template #SimpleCol let-data="params">
  <app-column-control-simple
    class="table-col"
    [row]="row"
    [column]="data.col"
    [style]="data.col.cssStyle"
  ></app-column-control-simple>
</ng-template>

<ng-template #DateCol let-data="params">
  <app-column-control-date class="table-col" [row]="row" [column]="data.col"></app-column-control-date>
</ng-template>

<ng-template #LinkCol let-data="params">
  <app-column-control-link class="table-col" [row]="row" [column]="data.col"></app-column-control-link>
</ng-template>

<ng-template #ButtonCol let-data="params">
  <app-column-control-button
    class="table-col table-col-button"
    [row]="row"
    [column]="data.col"
  ></app-column-control-button>
  <!-- {{row | json}} -->
</ng-template>

<ng-template #ButtonsCol let-data="params">
  <app-column-control-actions
    class="table-col table-col-button table-col-action"
    [row]="row"
    [column]="data.col"
  ></app-column-control-actions>
</ng-template>
